export default "__VITE_ASSET__BN8ml9AK__"